import React from "react";
import styled from "styled-components";
import { P } from "../"; // TODO: Set marker color according to a theme color

const formatPercentage = value => {
  return value.toString() + "%";
};

const getPosition = (value, maxValue) => {
  return value / maxValue * 100;
};

const iconStyle = {
  width: "15px",
  marginRight: "5px"
};
const Bar = styled.div`
  position: relative;
  height: 10px;
  margin: 24px 8px;
  background-color: ${props => props.theme.colors.disabledText};
  border-radius: 10px;
`;
const ProgressInBar = styled(Bar)`
  position: absolute;
  margin: 0;
  width: ${props => `${formatPercentage(props.width)}`};
  background-color: ${props => props.theme.colors.green};
  z-index: 1;
`;
const SectionStartMarker = styled.div`
  position: absolute;
  height: 100%;
  width: 2px;
  left: ${props => `${formatPercentage(props.position)}`};
  background-color: ${props => props.theme.colors.text};
  z-index: 2;
`;
const SectionLabelContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  ${props => props.top && `top: -24px;`}
  ${props => !props.top && `bottom: -24px;`}
  ${props => props.last && `right: 0;`}
  ${props => !props.last && `left: ${formatPercentage(props.leftPosition)};`}
`;
const SectionText = styled(P)`
  font-size: 12px;
`;
const SectionValueText = styled(SectionText)`
  font-style: italic;
  color: ${props => props.theme.colors.disabledText};
`;
const SectionLabelText = styled(SectionText)`
  color: ${props => props.highlight ? props.theme.colors.white : props.theme.colors.disabledText};
`;
export const SupportLevelBar = ({
  value,
  sections
}) => {
  const maxValue = sections[sections.length - 1].value;

  const getProgressPercentage = (value, maxValue) => {
    return Math.min(getPosition(value, maxValue), 100);
  };

  const isCurrentSection = (value, sectionValue, nextSection) => {
    return value >= sectionValue && (nextSection ? value < nextSection.value : true);
  };

  return React.createElement(Bar, null, React.createElement(ProgressInBar, {
    width: getProgressPercentage(value, maxValue)
  }), sections.map((section, index) => {
    return React.createElement("div", null, index < sections.length - 1 && index > 0 && React.createElement(SectionStartMarker, {
      position: getPosition(section.value, maxValue)
    }), React.createElement(SectionLabelContainer, {
      top: true,
      leftPosition: getPosition(section.value, maxValue),
      first: index === 0,
      last: index === sections.length - 1
    }, isCurrentSection(value, section.value, sections[index + 1]) ? !!section.selectedIcon && React.createElement(section.selectedIcon, {
      style: iconStyle
    }) : !!section.unselectedIcon && React.createElement(section.unselectedIcon, {
      style: iconStyle
    }), React.createElement(SectionLabelText, {
      highlight: isCurrentSection(value, section.value, sections[index + 1])
    }, section.label)), React.createElement(SectionLabelContainer, {
      leftPosition: getPosition(section.value, maxValue),
      first: index === 0,
      last: index === sections.length - 1
    }, React.createElement(SectionValueText, null, "$", index === sections.length - 1 ? section.value.toString() + "+" : section.value)));
  }));
};